const MILLISECONDS_PER_DAY = 1000 * 3600 * 24;

const DATE_LABEL_MAP: Record<number, string> = Object.freeze({
  0: "Today",
  1: "Yesterday",
  2: "2 days ago",
  3: "3 days ago",
  4: "4 days ago",
  5: "5 days ago",
  6: "6 days ago",
  7: "a week ago",
});

/**
 * Converts a Date into a string such as "Yesterday", "N days ago", up to a "a week ago"
 */
export const toTimeAgoFormat = (date: Date, { now = new Date() } = {}) => {
  if (
    Object.prototype.toString.call(date) !== "[object Date]" ||
    isNaN(date as unknown as number)
  ) {
    return "";
  }
  /**
   * Calling toUTC normalizes the date that is used to calculate the offset
   * such that changes in daylight savings time is accounted for correctly.
   */
  const millisecondsDifference = toUTC(now).getTime() - toUTC(date).getTime();
  const dayDifference = Math.max(
    Math.floor(millisecondsDifference / MILLISECONDS_PER_DAY),
    0
  );

  return (
    DATE_LABEL_MAP[dayDifference] ||
    date.toLocaleDateString("en-US", {
      day: "numeric",
      month: "long",
      year: "numeric",
    })
  );
};

function toUTC(date: Date) {
  date = new Date(date);
  date.setMinutes(date.getMinutes() - date.getTimezoneOffset());
  return date;
}
